import React from "react"
import PropTypes from "prop-types"
import {
    PictureAsPdfOutlined,
    LinkOutlined,
    OpenInNew,
    FileDownloadOutlined
} from "@mui/icons-material"

/**
 * A lecture's downloadable files and links. Both open in a new tab: links
 * are pages, and the browser downloads or previews uploaded files itself.
 * `actions(resource)` optionally renders controls at the end of each row.
 */
export default function ResourceList({ resources, actions }) {
    if (!resources || resources.length === 0) return null

    return (
        <ul className="space-y-2">
            {resources.map((resource) => {
                const isFile = resource.kind === "file"
                return (
                    <li
                        key={resource.resource_id}
                        className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white p-2 pl-3"
                    >
                        <span className={isFile ? "text-rose-500" : "text-indigo-500"}>
                            {isFile ? (
                                <PictureAsPdfOutlined fontSize="small" />
                            ) : (
                                <LinkOutlined fontSize="small" />
                            )}
                        </span>
                        <a
                            href={resource.url}
                            target="_blank"
                            rel="noreferrer"
                            className="flex min-w-0 flex-1 items-center gap-1 py-1 text-sm font-medium text-slate-700 hover:text-indigo-600"
                        >
                            <span className="truncate">{resource.title}</span>
                            {isFile ? (
                                <FileDownloadOutlined sx={{ fontSize: 16 }} />
                            ) : (
                                <OpenInNew sx={{ fontSize: 14 }} />
                            )}
                        </a>
                        {actions && actions(resource)}
                    </li>
                )
            })}
        </ul>
    )
}

ResourceList.propTypes = {
    resources: PropTypes.array,
    actions: PropTypes.func
}
